/**
 * Global configuration for 'sonner' toast notifications.
 * Extracted from App.jsx to maintain clean component logic.
 */
export const toasterConfig = {
    position: "top-center",
    richColors: true,
    expand: true,
    visibleToasts: 6,
    gutter: 12,
    containerStyle: {
      zIndex: 9999,
      pointerEvents: 'none',
    },
    toastOptions: {
      duration: 5000,
      style: {
        borderRadius: '10px',
        padding: '14px 18px',
        boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
        fontSize: '14px',
        fontWeight: 500,
        pointerEvents: 'auto',
      },
      className: 'custom-toast',
      pauseOnHover: true,
      ariaProps: {
        role: 'status',
        'aria-live': 'polite',
      },
      newestOnTop: true,
      success: {
        icon: '✅',
        style: { background: '#4CAF50', color: '#fff' },
      },
      error: {
        icon: '❌',
        style: { background: '#F44336', color: '#fff' },
      },
      warning: {
        icon: '⚠️',
        style: { background: '#FF9800', color: '#fff' },
      },
      info: {
        icon: 'ℹ️',
        style: { background: '#2196F3', color: '#fff' },
      },
    }
};
